import React from 'react'
import {OverlayTrigger, Tooltip} from "react-bootstrap"

function NameComponent({item, id, name, status, status_name, selectItem, showModalStatus, showBtn=false, titleclass = ""}) {

    const changeStatus = (item) => {
        selectItem(item);
        showModalStatus(true);
    }


    let nameformat = name.split(" ");

    return (
        <div className="content-name-file">

            {(status && status === "N") 
                ? 
                <span className="badge badge-sm small mb-2 badge-success font-weight-bold">
                    {status_name}
                </span> 
                : 
                ""
            }

            {(status && status === "D") 
                ? 
                <span className="badge badge-sm small mb-2 badge-danger font-weight-bold">
                    {status_name}
                </span> 
                : 
                ""
            }

            {(status && status === "D") 
            ?
                <h4 className={`${titleclass !== "" ? titleclass : 'h5 text-black mb-1'} wspace-no`}>
                    <div className="content-file-title">
                        {nameformat.map((item, key) => {
                            if(item.length < 30){
                                return (
                                    <span className={`title-wrap`} key={key}>
                                        {item}
                                    </span>
                                )
                            }else{
                                let separarLetras = item.match(/.{1,30}(.$)?/g);
                                //console.log(separarLetras);

                                return separarLetras.map((subitem, subkey) => {
                                    return (
                                        <span className={`title-wrap ${(item.length > 29) ? "letter-wrap" : ""}`} key={subkey}>
                                            {subitem}
                                        </span>
                                    )
                                })
                            }
                        })}
                        {(showBtn) &&
                            <OverlayTrigger
                                placement="right"
                                overlay={
                                    <Tooltip id={`change-status-file-id-${id}`}>
                                        Editar.
                                    </Tooltip>
                                }
                                >
                                    <button onClick={() => changeStatus(item)} className="btn btn-sm py-0 ml-2">
                                        <i className="fa fa-ellipsis-v"></i>
                                    </button>
                            </OverlayTrigger>
                        }
                    </div> 
                </h4>
            :
                <h4 className={`${titleclass !== "" ? titleclass : 'h5 text-black mb-1'} wspace-no`}>
                    <div className="content-file-title">
                        {nameformat.map((item, key) => {
                            if(item.length < 30){
                                return (
                                    <span className={`title-wrap`} key={key}>
                                        {item}
                                    </span>
                                )
                            }else{
                                let separarLetras = item.match(/.{1,30}(.$)?/g);
                                //(separarLetras);

                                return separarLetras.map((subitem, subkey) => {
                                    return (
                                        <span className={`title-wrap ${(item.length > 29) ? "letter-wrap" : ""}`} key={subkey}>
                                            {subitem}
                                        </span>
                                    )
                                })
                            }
                        })} 
                    
                        {(showBtn) &&
                            <OverlayTrigger
                                placement="right"
                                overlay={
                                    <Tooltip id={`change-status-file-id-${id}`}>
                                        Editar.
                                    </Tooltip>
                                }
                                >
                                    <button onClick={() => changeStatus(item)} className="btn btn-sm py-0 ml-2">
                                        <i className="fa fa-ellipsis-v"></i>
                                    </button>
                            </OverlayTrigger>
                        }
                    </div>
                </h4>
            }
        </div>
    )
}

export default NameComponent
